import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { FormItem, FormInputChoice } from '@tesla/design-system-react';
import { useField } from 'informed';
import { FeedBack } from './Feedback.js';

var _excluded = ["label", "feedback", "helper", "caption", "tooltip"];
function Checkbox(props) {
  var _useField = useField(_objectSpread2({
      type: 'checkbox'
    }, props)),
    informed = _useField.informed,
    fieldState = _useField.fieldState,
    render = _useField.render,
    userProps = _useField.userProps,
    ref = _useField.ref;
  var label = userProps.label,
    feedback = userProps.feedback,
    helper = userProps.helper,
    caption = userProps.caption,
    tooltip = userProps.tooltip,
    inputProps = _objectWithoutProperties(userProps, _excluded);
  var disabled = inputProps.disabled,
    readonly = inputProps.readonly,
    id = inputProps.id;
  var showError = fieldState.showError,
    error = fieldState.error,
    value = fieldState.value;
  return render( /*#__PURE__*/React.createElement(FormItem, {
    error: showError,
    variant: "choice",
    disabled: disabled
  }, /*#__PURE__*/React.createElement(FormInputChoice, _extends({}, informed, inputProps, {
    id: id,
    label: label,
    labelProps: {
      caption: caption,
      tooltip: tooltip
    },
    inputRef: ref,
    readOnly: readonly,
    checked: !!value,
    disabled: disabled
  })), /*#__PURE__*/React.createElement(FeedBack, {
    feedback: feedback,
    helper: helper,
    error: error,
    showError: showError
  })));
}

export { Checkbox };
